import MasterComponent from "~/components/pages/supervisor/LargeDataMaster";

export default function LargeDataMaster() {
  return (
    <div className="z-10">
      <MasterComponent />
    </div>
  );
}
  